import { StartRocket } from "../start-rocket"
import { RigidBody } from "@react-three/rapier"
import { useEffect, useRef } from "react"
import { gsap } from "gsap"
import * as THREE from "three"
import { useThree } from "@react-three/fiber"
import { playerStore } from "../../../../store/player.store"
import { observer } from "mobx-react"

const StartTable = observer(({model}) => {
  const mapRef = useRef();
  const flagRef = useRef();
  const {camera} = useThree()
  const checkDistance = (objectPosition) => {
    const cameraPosition = new THREE.Vector3();
    camera.getWorldPosition(cameraPosition);
    const objectPositionVec = new THREE.Vector3(...objectPosition); // розпаковуємо масив координат
    const distance = cameraPosition.distanceTo(objectPositionVec);

    return distance <= 1.5;
  };

  const onHoverHandler = () => {
    if (!checkDistance([-13.9, 1.19, 0.761])) return
    const mapMesh = mapRef.current;
    const flagMesh = flagRef.current;

    if (!mapMesh || !flagMesh) return;

    gsap.timeline()
      .to(mapMesh.scale, { x: 1, y: 1, z: 1, duration: 1 })

    gsap.timeline()
      .to(flagMesh.scale, { x: 1, y: 1, z: 1, duration: 1 })

    setTimeout(() => {
      gsap.timeline()
        .to(mapMesh.scale, { x: 0, y: 0, z: 0, duration: .5 })

      gsap.timeline()
        .to(flagMesh.scale, { x: 0, y: 0, z: 0, duration: .5 })
    }, 4000)
  }


  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.scale.set(0, 0, 0); // Установка скейлу в 0
    }
    if (flagRef.current) {
      flagRef.current.scale.set(0, 0, 0); // Установка скейлу в 0
    }
  }, [])

  return (
    <>
      <primitive object={model.nodes["start_map"]} />

      {
        !playerStore.isPenInPlayer && (
          <primitive object={model.nodes["pen"]} />
        )
      }

      <group
        onPointerOver={() => {
          if (playerStore.isPenInPlayer) return
          playerStore.setActiveNote("get pen")
        }}
        onPointerOut={() => {
          playerStore.clearActiveNote()
        }}
        onClick={() => {
          if (playerStore.isPenInPlayer) return
          playerStore.setPenToPlayer()
        }}
      >
        <primitive object={model.nodes["pen_box"]} />
      </group>

      <primitive ref={mapRef} object={model.nodes["country_map"]} />
      <primitive ref={flagRef} object={model.nodes["country_flag"]} />

      <mesh
        onPointerOver={onHoverHandler}
        rotation={[0, 0, 0]}
        position={[-13.9, 1.19, 0.761]}
      >
        <boxGeometry args={[0.03, 0.03, 0.05]} />
        <meshStandardMaterial transparent={true} opacity={0} />
      </mesh>

      <StartRocket model={model} />
      <RigidBody type="fixed" colliders="trimesh">
        <primitive object={model.nodes["start_table_cool"]} />
      </RigidBody>
    </>

  )
})

export {
  StartTable
}